const count_num = (elements, time = 3000) => {

    let $elements = $(elements);

    $elements.each(function () {

        let i = 1;
        let ths = $(this);
        let num = Number(ths.data('number'));
        let timeout = time / (num * i);

        let interval = setInterval(function () {
            i+= 1;
            if (i <= num) {
                ths.text(i);
            } else {
                clearInterval(interval);
            }
        }, timeout);

    });

};


export default count_num;